var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81553 6.93807C4.21364 7.50678 5.0559 7.50678 5.454 6.93807L8.53334 2.539C8.99728 1.87623 8.52313 0.96554 7.71411 0.96554L1.55542 0.965541C0.746397 0.965541 0.272244 1.87623 0.736189 2.539L3.81553 6.93807Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81553 6.93807C4.21364 7.50678 5.0559 7.50678 5.454 6.93807L8.53334 2.539C8.99728 1.87623 8.52313 0.96554 7.71411 0.96554L1.55542 0.965541C0.746397 0.965541 0.272244 1.87623 0.736189 2.539L3.81553 6.93807Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownPolygon);
export default __webpack_public_path__ + "static/media/dropdown_polygon.cd6f36030e1e2b514c0aba8d25677ffa.svg";
export { ForwardRef as ReactComponent };